'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ClipboardIcon = require('./ClipboardIcon');

var _ClipboardIcon2 = _interopRequireDefault(_ClipboardIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ClipboardIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ClipboardIcon/index.js
// module id = 558
// module chunks = 11